import React, { useState, useEffect } from "react";
import styles from "./SignupForm.module.css";
import { Link, useNavigate } from "react-router-dom";
import formImage from "../../assets/formImage.png";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { auth, facebook } from "../../firebase-config";
import { signInWithPopup } from "firebase/auth";
import emailjs from "emailjs-com";
import { useLocation } from "react-router-dom";

import google from "./image/google.png";
import facebook1 from "./image/facebook.png";
import inggage from "../../assets/inggage.png";

import "aos/dist/aos.css";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { set } from "firebase/database";
import { toast } from "react-hot-toast";

const SignupForm = () => {
  const [userType, setUserType] = useState("");
  useEffect(() => {
    setUserType(localStorage.getItem("userType"));
    setFormData((prev) => ({
      ...prev,
      userType: localStorage.getItem("userType"),
    }));
  }, []);
  // console.log("User Type:", userType);

  //console.log("Selected Role:", selectedRole);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    displayName: "",
    profile_image: "",
    // otp: "",
    createdAt: "",
    isVerified: false,
    userType: "",
  });
  const [user, setUser] = useState([]);
  // const [otpSent, setOtpSent] = useState(false);
  // const [generatedOtp, setGeneratedOtp] = useState("");
  const navigate = useNavigate();

  //Login with Google
  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setUser(codeResponse);
    },
    onError: (error) => console.log("Login Failed:", error),
    ux_mode: "popup",
    mode: "cors",
  });

  // to format time and date
  function formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    // Get the date in 'YYYY-MM-DD' format (Indian locale)
    const formattedDate = date.toLocaleDateString("en-CA"); // 'en-CA' for ISO-like date format (YYYY-MM-DD)
    // Get the time in 'HH:MM' format (Indian Standard Time)
    const formattedTime = date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata", // Set timezone to IST
    });
    return `${formattedDate} ${formattedTime}`;
  }

  useEffect(() => {
    // Get current timestamp and format it
    const currentTimestamp = new Date().toISOString();
    const formattedCreatedAt = formatTimestamp(currentTimestamp);

    if (user && user.access_token) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          const updatedFormData = {
            email: res.data.email,
            displayName: res.data.name,
            password: "",
            profile_image: res.data.picture,
            isVerified: res.data.verified_email,
            createdAt: formattedCreatedAt,
          };
          setFormData(updatedFormData);
          localStorage.setItem("formData", JSON.stringify(updatedFormData));
          navigate("/Signupform");
        })
        .catch((err) => console.log(err));
    }
  }, [user, navigate]);

  // Login with Facebook
  const loginFace = async (provider) => {
    // Get current timestamp and format it
    const currentTimestamp = new Date().toISOString();
    const formattedCreatedAt = formatTimestamp(currentTimestamp);
    try {
      const result = await signInWithPopup(auth, provider);
      console.log(result.user);

      const updatedFormData = {
        email: result.user.email,
        displayname: result.user.displayName,
        password: "",
        isVerified: result.user.emailVerified,
        profile_image: result.user.photoURL,
        createdAt: formattedCreatedAt,
      };
      setFormData(updatedFormData);
      localStorage.setItem("formData", JSON.stringify(updatedFormData));
      navigate("/Signupform");
    } catch (e) {
      console.log(`login error ${e}`);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Get current timestamp and format it
    const currentTimestamp = new Date().toISOString();
    const formattedCreatedAt = formatTimestamp(currentTimestamp);

    formData.createdAt = formattedCreatedAt;


    if(!formData?.password){
     toast("Please enter your password");
     return;
      }

    if (!formData.displayName) {
      toast("Please enter your name ");
      return;
    }

    if (!formData.email) {
      toast("Please enter your email");
    } else {
      if (
        // eslint-disable-next-line
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(formData.email)
      ) {
        localStorage.setItem("formData", JSON.stringify(formData));
        navigate("/Signupform");
      } else {
        toast("Invalid Email. Please try again.");
      }
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className="flex md:flex-row xs:flex-col items-center justify-center md:m-10 xs:m-2 " style={{fontFamily:"Gilroy-Medium"}}>


        <div className="md:w-1/2 xs:w-full flex items-center justify-center">
          <img src={inggage} alt="formimage" className="w-3/4"></img>
        </div>

        <div className="md:w-1/2 xs:w-full flex  items-center justify-center  ">
          <form onSubmit={handleSubmit} className="border-2 border-gray-300 md:w-3/4 xs:w-full m-4 p-4 rounded-lg ">
            <h2 className="text-2xl text-left">{userType==="Influencer" ? "Creator Signup" : "Brand Signup"}</h2>
            <p className="text-gray-500 text-sm mb-3">
              We will require your email ID to further proceed and get in touch
              with our team
            </p>

            <input
              className={styles.inputField}
              type="text"
              name="displayName"
              value={formData.displayName}
              onChange={handleChange}
              placeholder="    Enter Your Name"
            />
            <input
              className={styles.inputField}
              type="text"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="    Enter your Email ID"
            />

            <div className="mb-2 w-full relative">
              <input
                className={styles.inputField}
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="    Set your password"
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute inset-y-0 right-0 px-3 py-2 text-gray-600 flex justify-center items-center mt-1"
              >
                {showPassword ? (
                  <div>
                    <FaEye />
                  </div>
                ) : (
                  <div>
                    <FaEyeSlash />
                  </div>
                )}
              </button>
            </div>

            <button type="submit" className="w-full bg-[#ea0063] font-bold p-2 rounded-lg text-white">
              Continue
            </button>

            <div className={styles.orText}>OR</div>
            <div className="flex justify-center items-center mt-2 gap-4 buttonContainer">
              <img
                src={google}
                type="submit"
                onClick={() => login()}
                alt="Google logo 24px"
                className="cursor-pointer w-[40px] h-[40px] border-2 rounded-full border-gray-300 p-1 hover:border-blue-500 transition duration-300"
                
              />
              <img
                src={facebook1}
                type="submit"
                onClick={() => loginFace(facebook)}
                alt="Facebook logo 24px"
                className="cursor-pointer w-[40px] h-[40px] border-2 rounded-full border-gray-300 p-1 hover:border-blue-500 transition duration-300"
              />
            </div>
            <div className={styles.NavContainer}>
              <Link to="/login" className={styles.NavSignup}>
             
                <span className="text-gray-500 text-sm">
                  Already have an account?
                </span>
                <span className="text-blue-500 text-sm"> Login Here</span>
              </Link>
            </div>
          </form>
        </div>


      </div>
    </>
  );
};

export default SignupForm;
